<div class="page-header-container flex-utility align-center justify-space-between">
    <div class="left-wrapper flex-utility align-center">
        <i (click)="goBack()" *ngIf="isBack" class="material-icons">arrow_right_alt</i>
        <img *ngIf="!isBack" [src]="icon" alt="">
        <span class="page-header-title">{{title | translate}}</span>
    </div>

    <div class="right-wrapper flex-utility align-center">
        <!-- * EXPORT * -->
        <button (click)="doExportAction()" mat-button class="export-button" *ngIf="hasExportAction">
            <div class="flex-utility align-center">
                <div class="avatar-product-container">
                    <img class="icon-export" src="../../../assets/images/export.svg" alt="export_icon">
                </div>
                <div [innerHTML]="exportLabel | translate">
                </div>
            </div>
        </button>

        <!-- * COLUMN VISIBILITY * -->
        <app-column-visibility [isVisible]="hasColumnVisibility"></app-column-visibility>
        <!-- * END COLUMN VISIBILITY * -->


        <!-- * SELECT * -->
        <app-select-bulgari [showSelect]="hasSelect" [optionSelected]="optionSelected"
            [optionLabelProp]="optionLabelProp" [optionValueProp]="optionValueProp" [selectOptions]="selectOptions"
            (handle_onAction)="triggerAction($event)"></app-select-bulgari>
        <!-- * END SELECT * -->

        <app-bulgari-button [ngClass]="{'disabled': actionIsDisabled}" [disabled]="actionIsDisabled"
            (click)="triggerAction(true)" [type]="styleActionButton" *ngIf="hasAction"
            [text]="actionLabel"></app-bulgari-button>

        <button (click)="doRefreshAction()" mat-button class="refresh-button" *ngIf="hasRefresh">
            <div class="flex-utility align-center">
                <div [innerHTML]="'BUTTON.REFRESH' | translate">
                </div>
            </div>
        </button>
    </div>
</div>
